import { Box, useMediaQuery, useTheme } from "@mui/material";

import React from "react";
import { MainDashboard } from "./MainDashboard";
import { UpsellDashboard } from "../upselling/UpsellDashboard";
import { TabsList } from "../../components/Tabs/TabsList";
import { MobileAppDashboard } from "./MobileAppDashboard";
import { PushPermissionBanner } from "../Notifications/components/PushPermissionBanner";

function TabPanel({ children, value, index }: any) {
  return value === index ? <Box sx={{ mt: 3 }}>{children}</Box> : null;
}

export function DesktopDashboard() {
  const [tab, setTab] = React.useState(0);

  return (
    <Box sx={{ minHeight: "100vh", overflowX: "hidden", maxWidth: "100%" }}>
      {/* <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                    <Typography variant="h3" fontWeight={700}>
                        Welcome to EDGENROOTS 2 Dashboard
                    </Typography>
                </CardContent>
                <Tabs
                    value={tab}
                    onChange={(_, newValue) => setTab(newValue)}
                    centered
                >
                    <Tab label="Overview" sx={{fontWeight: 700, fontSize: 18}} />
                    <Tab label="Upsell Dashboard" sx={{fontWeight: 700, fontSize: 18}} />
                </Tabs>
            </Card> */}
      <PushPermissionBanner />

      <TabsList
        selectedTab={tab}
        tabs={[{ label: "Overview" }, { label: "Upsell Dashboard" }]}
        varaint="fullWidth"
        onChange={(_, newValue) => setTab(newValue)}
        sx={{
          p: { xs: "4px", sm: "8px" },
          "& .MuiTab-root": {
            fontSize: { xs: "0.8rem", sm: "1rem" },
            padding: { xs: "8px", sm: "15px" },
            minHeight: { xs: 36, sm: 48 },
          },
        }}
      />

      <Box>
        <TabPanel value={tab} index={0}>
          <MainDashboard />
        </TabPanel>

        <TabPanel value={tab} index={1}>
          <UpsellDashboard />
        </TabPanel>
      </Box>
    </Box>
  );
}

export function AppDashboard() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  if (!isDesktop) {
    return <MobileAppDashboard />;
  }

  return <DesktopDashboard />;
}
